import React from "react";
import { useNavigate } from "react-router-dom";

// Utils
import { contact_us } from "../utils/data/contact-us";

// Images
import DAIICT_LOGO from "../images/DAIICT.png";

// Material-UI Components
import { Box, Typography, Grid, Link, IconButton } from "@mui/material";

function Footer() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        bgcolor: "#0F172A",
        color: "white",
        py: { xs: 3, sm: 4, md: 5 },
        px: { xs: 2, sm: 4, md: 6 },
        borderTop: "1px solid white",
      }}
    >
      <Grid container spacing={4}>
        {/* Section 1: Quick Links */}
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Quick Links
          </Typography>
          <Box>
            {["Home", "Events", "Members", "Contact Us"].map((link, index) => (
              <Typography
                key={index}
                variant="h6"
                onClick={() =>
                  navigate(
                    index ? `/${link.toLowerCase().replace(/\s/g, "-")}` : "/"
                  )
                }
                sx={{
                  display: "block",
                  mt: 1,
                  cursor: "pointer",
                  transition: "transform 0.1s ease-in-out",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "black",
                    transform: "scale(1.01)",
                    transition: "transform 0.1s ease-in-out",
                  },
                }}
              >
                {link}
              </Typography>
            ))}
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img src={DAIICT_LOGO} alt="DAIICT_LOGO" style={{ width: 150 }} />
        </Grid>

        {/* Section 3: Contact */}
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Contact Us
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              gap: 1,
            }}
          >
            <IconButton
              sx={{
                width: 40, // Equal width
                height: 40, // Equal height
                borderRadius: "50%", // Makes it a perfect circle
                bgcolor: "rgba(255, 255, 255, 0.1)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
              }}
              onClick={() => window.open(contact_us.github, "_blank")}
            >
              <i className="fa-brands fa-github" style={{ color: "white" }}></i>
            </IconButton>
            <IconButton
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                bgcolor: "rgba(255, 255, 255, 0.1)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
              }}
              onClick={() => window.open(contact_us.linkedin, "_blank")}
            >
              <i
                className="fa-brands fa-linkedin"
                style={{ color: "white" }}
              ></i>
            </IconButton>
            <IconButton
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                bgcolor: "rgba(255, 255, 255, 0.1)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
              }}
              onClick={() => window.open(contact_us.youtube, "_blank")}
            >
              <i
                className="fa-brands fa-youtube"
                style={{ color: "white" }}
              ></i>
            </IconButton>
            <IconButton
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                bgcolor: "rgba(255, 255, 255, 0.1)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
              }}
              onClick={() => window.open(contact_us.instagram, "_blank")}
            >
              <i
                className="fa-brands fa-instagram"
                style={{ color: "white" }}
              ></i>
            </IconButton>
          </Box>

          <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
            {contact_us.address}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Email:{" "}
            <Link
              href="mailto:contact@mstcdaiict.com"
              color="inherit"
              underline="hover"
            >
              {contact_us.email}
            </Link>
          </Typography>
        </Grid>
      </Grid>

      {/* Footer Bottom */}
      <Box
        sx={{
          textAlign: "center",
          mt: { xs: 3, sm: 4 },
          pt: 2,
          borderTop: "1px solid rgba(255, 255, 255, 0.2)",
        }}
      >
        <Typography variant="body2">
          © {new Date().getFullYear()} Microsoft Student Technical Club,
          DA-IICT. All Rights Reserved.
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
